import React from 'react'
import CdnPath from "../../services/cdn_path";

const IncomingListModal = (props) => {
    const cspUrl = props.csp_basic_url

    const viewAllClicked = () => {
        const usersIds = props.openSlas.map(sla => sla.user_id).filter((v, i, a) => a.indexOf(v) === i)
        sessionStorage.setItem('accountUsers', usersIds)
        window.open(`/backend/accounts/${usersIds[0]}?nav` , '_blank');
    }

    const openZendeskTicket = (sla) => {
        console.log('--openCspTicket-', sla.ticket_id)
        window.open(`${cspUrl}/customer/${sla.csp_customer_id}/conversation/${sla.ticket_id}` , '_blank');
    }

    return (
        <div className={'pending-incoming-modal'}>
            <div className={'title'}>
                <span className={'desc'}> Pending Communications </span>
                <span className={'link'} onClick={viewAllClicked}>View all</span>
            </div>
            <div className={'pending-incoming-list'}>{
                props.openSlas.map((sla, i) => {
                    return (
                        <div key={i} className={'incoming-item'}>
                            <div className={`ellipse ${sla.priority}`}></div>
                            <div className={'incoming-content'}>
                                <div className={'description'} onClick={() => openZendeskTicket(sla)}>
                                    <span>{sla.description}</span>
                                    <img src={CdnPath("backend/icons/open-link-icon.svg")} alt="open-link-icon" />
                                </div>
                                <div className={'text-details'}>
                                    <div className={'name'}> <a
                                       href={`/backend/accounts/${sla.user_id}`} target='_blank'>
                                        {sla.user_name}</a> </div>
                                    <div className={'date'}>{sla.received_at}</div>
                                </div>
                            </div>
                        </div>
                    )
                })
            }</div>
        </div>
    )
}

export default IncomingListModal
